import axios from "axios";
// docs/security-and-platform-work-plan.md Этап 7 — the access token is an
// HttpOnly cookie now, sent automatically via withCredentials below; no
// interceptor can read it to build an Authorization header anymore (this
// one used to, reading it from a JS-readable cookie that no longer exists).
export const api = axios.create({baseURL: process.env.REACT_APP_API_URL || "https://qa-api-admin.id.express/v1", withCredentials:true, headers:{"X-Requested-With":"XMLHttpRequest"}});
